export default function handleUpdateState(state, maskValue) {
  const updateObj = {};
  updateObj[state] = maskValue;

  this.setState(updateObj);
}
